import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithStraplineFormSectionType = {
  _initStrapline(strapline: string): void;
  _initStraplineValueChanges(getPreviousStrapline: () => string | null): void;
  _buildStrapline(): string;
};

type StraplineFormSectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: { STRAPLINE: () => string };
  destroy$: Subject<boolean>;
};

export function WithStraplineFormSection<
  TBase extends Constructor<StraplineFormSectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithStraplineFormSectionType;
  prototype: WithStraplineFormSectionType;
} & TBase {
  return class WithStraplineFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initStrapline(strapline: string): void {
      this.form.get(this.FORM_PATHS.STRAPLINE()).setValue(strapline);
    }

    _initStraplineValueChanges(
      getPreviousStrapline: () => string | null
    ): void {
      this.form
        .get(this.FORM_PATHS.STRAPLINE())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousStrapline()) {
              this.form.get(this.FORM_PATHS.STRAPLINE()).markAsPristine();
            }
          },
        });
    }

    _buildStrapline(): string {
      return this.form.get(this.FORM_PATHS.STRAPLINE()).value;
    }
  };
}
